import { BaseModel } from '../../../../../../core/_base/crud';

    export class DeNghiMuaHang extends BaseModel {
       
        static optionsLoaiPhieu: any = [
            {
                id: 1,
                value: 'NHUCAUPHATSINH',
                name: 'Nhu cầu phát sinh'
            },
            {
                id: 2,
                value: 'NHUCAUKEHOACH',
                name: 'Nhu cầu kế hoạch'
            }
        ];

        static optionsTinhTrang:any = [
            {
                id: 1,
                name: 'Đang soạn thảo',
                value: 'PDNMH_PHIEUMOI',
            },
            {
                id: 2,
                name: 'Chờ xử lý',
                value: 'PDNMH_CHODUYET',
            },
            {
                id: 3,
                name: 'Hoàn tất',
                value: 'PDNMH_HOANTAT',
            },
            {
                id: 4,
                name: 'Đã hủy',
                value: 'PDNMH_DAHUY',
            },
            
        ];

        Id: number
        SoPhieu: string
        LoaiPhieu: string
        LoaiHangHoaYeuCau: number
        NgayDeNghiCoHang: string
        NgayYeuCau: string
        NguoiYeuCau: number
        TenNguoiYeuCau: string
        PhongBanId: number
        TenPhongBan: string
        DienGiaiLyDo: string
        Nguoitao: number
        TenNguoiTao: string
        Ngaytao: string
        Nguoisua: string
        Ngaysua: string
        IsCreatePo: boolean
        NguoiXacNhan: number
        TenNguoiXacNhan: string
        ThoiGianXacNhan: string
        TpDuyetId: number
        TenTP: string
        TpDuyetLyDo: string
        TpDuyetThoiGian: string
        GdduyetId: number
        TenGD: string
        GdduyetLyDo: string
        GdduyetThoiGian: string
        TpDuyetValue: number
        GdDuyetValue: number
        TinhTrang: string
        TenTinhTrang: string
        TongTien: string
        isVuotHanMuc: boolean
        HanMucLapPhieu: string
        listChiTietMuaHang: DeNghiMuaHangCT[]
        listPhieuDeNghiLsThaoTac: PhieuDeNghiLsThaoTac[]

        clear() {
            this.Id = 0;
            this.SoPhieu = '';
            this.LoaiPhieu= '';
            this.LoaiHangHoaYeuCau= 0;
            this.NgayDeNghiCoHang= '';
            this.NgayYeuCau= '';
            this.NguoiYeuCau= 0;
            this.TenNguoiYeuCau = '';
            this.PhongBanId= 0;
            this.TenPhongBan= '';
            this.DienGiaiLyDo= '';
            this.Nguoitao= 0;
            this.TenNguoiTao= '';
            this.Ngaytao= '';
            this.Nguoisua= '';
            this.Ngaysua= '';
            this.IsCreatePo= false;
            this.NguoiXacNhan= 0;
            this.TenNguoiXacNhan= '';
            this.ThoiGianXacNhan= '';
            this.TpDuyetId= 0;
            this.TenTP= '';
            this.TpDuyetLyDo= '';
            this.TpDuyetThoiGian= '';
            this.GdduyetId= 0;
            this.TenGD= '';
            this.GdduyetLyDo= '';
            this.GdduyetThoiGian= '';
            this.TpDuyetValue= 0;
            this.GdDuyetValue= 0;
            this.TinhTrang= '';
            this.TenTinhTrang= '';
            this.TongTien= '';
            this.HanMucLapPhieu = '';
            this.isVuotHanMuc = false;
            this.listChiTietMuaHang = [];
            this.listPhieuDeNghiLsThaoTac = [];
        }
        copy(item:DeNghiMuaHang){
            this.Id = item.Id;
            this.SoPhieu = item.SoPhieu;
            this.LoaiPhieu= item.LoaiPhieu;
            this.LoaiHangHoaYeuCau= item.LoaiHangHoaYeuCau;
            this.NgayDeNghiCoHang=item.NgayDeNghiCoHang;
            this.NgayYeuCau= item.NgayYeuCau;
            this.NguoiYeuCau= item.NguoiYeuCau;
            this.TenNguoiYeuCau = item.TenNguoiYeuCau;
            this.PhongBanId= item.Id;
            this.TenPhongBan= item.TenPhongBan;
            this.DienGiaiLyDo= item.DienGiaiLyDo;
            this.Nguoitao= item.Nguoitao;
            this.TenNguoiTao= item.TenNguoiTao;
            this.Ngaytao= item.Ngaytao;
            this.Nguoisua= item.Nguoisua;
            this.Ngaysua= item.Ngaysua;
            this.IsCreatePo= item.IsCreatePo;
            this.NguoiXacNhan= item.NguoiXacNhan;
            this.TenNguoiXacNhan= item.TenNguoiXacNhan;
            this.ThoiGianXacNhan= item.ThoiGianXacNhan;
            this.TpDuyetId= item.TpDuyetId;
            this.TenTP= item.TenTP;
            this.TpDuyetLyDo= item.TpDuyetLyDo;
            this.TpDuyetThoiGian= item.TpDuyetThoiGian;
            this.GdduyetId= item.GdduyetId;
            this.TenGD= item.TenGD;
            this.GdduyetLyDo= item.GdduyetLyDo;
            this.GdduyetThoiGian= item.GdduyetThoiGian;
            this.TpDuyetValue= item.TpDuyetValue;
            this.GdDuyetValue= item.GdDuyetValue;
            this.TinhTrang= item.TinhTrang;
            this.TenTinhTrang= item.TenTinhTrang;
            this.TongTien= item.TongTien;
            this.HanMucLapPhieu = item.HanMucLapPhieu;
            this.isVuotHanMuc = item.isVuotHanMuc;
            this.listChiTietMuaHang = item.listChiTietMuaHang;
            this.listPhieuDeNghiLsThaoTac = item.listPhieuDeNghiLsThaoTac;
        }
    }

    export class DeNghiMuaHangCT extends BaseModel{

        Id: number;
        PhieuDeNghiId: number;
        HangHoaId: number;
        MaHang: string;
        TenHang: string;
        QuyCach: string;
        SoLuong: number;
        Dvt: number;
        TenDVT: string;
        GhiChu: string;
        DonGia: string;
        ThanhTien: string;
        NccId: number;
        MaNCC : string;
        TenNCC: string;
        NgayGiaoDuKien: string;
        GhiChuXacNhan: string;
        DaLapDonHang: boolean;
        TienTe_id: number;
        TienTe_Ten: string;
        Tygia: string;
        ThanhTienQuyDoi: string;
        IdPBSD: number
        TenPBSD: string
        NgayCan: string
        XuLy: DM_DuyetChiTietMH
        GiaDuKien: string
        Attachment_id: number
        DaNhanHang: boolean
        FileImport: FileImport

        clear(){
            this.Id = 0;
            this.PhieuDeNghiId= 0;
            this.HangHoaId= 0;
            this.MaHang = '';
            this.TenHang= '';
            this.QuyCach= '';
            this.SoLuong= 0;
            this.Dvt= 0;
            this.TenDVT= '';
            this.GhiChu= '';
            this.DonGia= '0';
            this.ThanhTien= '';
            this.NccId= 0;
            this.TenNCC= '';
            this.MaNCC = '';
            this.NgayGiaoDuKien= '';
            this.GhiChuXacNhan= '';
            this.DaLapDonHang= false;
            this.TienTe_id = 0;
            this.TienTe_Ten = '';
            this.Tygia = '1';
            this.ThanhTienQuyDoi = '';
            this.IdPBSD = 0;
            this.TenPBSD = '';
            this.NgayCan = '';
            this.XuLy = new DM_DuyetChiTietMH();
            this.GiaDuKien = '0,00';
            this.Attachment_id = 0;
            this.DaNhanHang = false;
            this.FileImport = null;
        }

        copy(item:DeNghiMuaHangCT){
            this.Id = item.Id;
            this.PhieuDeNghiId= item.PhieuDeNghiId;
            this.HangHoaId= item.HangHoaId;
            this.MaHang = item.MaHang;
            this.TenHang= item.TenHang;
            this.QuyCach= item.QuyCach;
            this.SoLuong= item.SoLuong;
            this.Dvt= item.Dvt;
            this.TenDVT= item.TenDVT;
            this.GhiChu= item.GhiChu;
            this.DonGia= item.DonGia;
            this.ThanhTien= item.ThanhTien;
            this.NccId= item.NccId;
            this.TenNCC= item.TenNCC;
            this.MaNCC = item.MaNCC;
            this.NgayGiaoDuKien= item.NgayGiaoDuKien;
            this.GhiChuXacNhan= item.GhiChuXacNhan;
            this.DaLapDonHang= item.DaLapDonHang;
            this.TienTe_id = item.TienTe_id;
            this.TienTe_Ten = item.TienTe_Ten;
            this.Tygia = item.Tygia;
            this.ThanhTienQuyDoi = item.ThanhTienQuyDoi;
            this.IdPBSD = item.IdPBSD;
            this.TenPBSD = item.TenPBSD;
            this.NgayCan = item.NgayCan;
            this.XuLy = item.XuLy;
            this.GiaDuKien = item.GiaDuKien;
            this.Attachment_id = item.Attachment_id;
            this.DaNhanHang = item.DaNhanHang;
            if(item.FileImport != null){
                this.FileImport = new FileImport();
                this.FileImport.copy(item.FileImport);
            }
            else{
                this.FileImport = new FileImport();
                this.FileImport.clear();
            }
        }
    }

    export class PhieuDeNghiLsThaoTac extends BaseModel{
        Id: number;
        PhieuDeNghiId: number;
        NguoiThaoTac: number;
        TenNguoiThaoTac: string;
        NgayThaoTac: string;
        LoaiThaoTac: string;
        NoiDung: string;
        GhiChu: string;

        clear(){
            this.Id = 0;
            this.PhieuDeNghiId = 0;
            this.NguoiThaoTac = 0;
            this.TenNguoiThaoTac = '';
            this.NgayThaoTac = '';
            this.LoaiThaoTac = '';
            this.NoiDung = '';
            this.GhiChu = '';
        }

        copy(item: PhieuDeNghiLsThaoTac){
            this.Id = item.Id;
            this.PhieuDeNghiId = item.PhieuDeNghiId;
            this.NguoiThaoTac = item.NguoiThaoTac;
            this.TenNguoiThaoTac = item.TenNguoiThaoTac;
            this.NgayThaoTac = item.NgayThaoTac;
            this.LoaiThaoTac = item.LoaiThaoTac;
            this.NoiDung = item.NoiDung;
            this.GhiChu = item.GhiChu;
        }
    }

    export class HHModel extends BaseModel{

        Id_HH: number
        TenHH: string
        MaHH: string
        Id_NhomHH: number
        DVT1: number
        TenDVT: string
        
        clear(){
            this.Id_HH = 0;
            this.TenHH ='';
            this.MaHH = '';
            this.Id_NhomHH = 0;
            this.DVT1 = 0;
        }
    }

    export class DM_DuyetChiTietMH extends BaseModel{
        Id : number
        PhieuDeNghi : number
        PhieuDeNghiCT : number
        ListXacNhanNhanHang  = []
        NguoiDuyet : number
        TenNguoiDuyet : string
        NgayDuyet : string
        LoaiThaoTac : string
        LyDo : string
        NgayDuyetDate: Date
        TenLoaiThaoTac: string
        CoKetQuaDuyet : boolean
        clear(){
            this.Id = 0
            this.PhieuDeNghi = 0
            this.PhieuDeNghiCT = 0
            this.ListXacNhanNhanHang  = []
            this.NguoiDuyet = 0
            this.TenNguoiDuyet = ''
            this.NgayDuyet = ''
            this.LoaiThaoTac = ''
            this.LyDo =''
            this.NgayDuyetDate = new Date()
            this.TenLoaiThaoTac = ''
            this.CoKetQuaDuyet = false
        }
    }

    export class FileImport extends BaseModel {
        idLoaiHH: number;
        base64: string;
        fileByte: any;
        filename: string;
        dienGiai: string;
        extension: string;
    
        clear() {
            this.idLoaiHH = 0;
            this.base64 = '';
            this.fileByte = null;
            this.filename = '';
            this.dienGiai = '';
            this.extension = '';
        }
    
        copy(item: FileImport) {
            this.idLoaiHH = item.idLoaiHH;
            this.base64 = item.base64;
            this.fileByte = item.fileByte;
            this.filename = item.filename;
            this.dienGiai = item.dienGiai;
            this.extension = item.extension;
        }
    }
    
  
